<template>
    <template v-for="(item, index) in data" :key="index">
        <li v-if="item.children && item.children.length == 0">
            <!-- v-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)" -->
            <a
                @click="navigate(item.id)"
                class="btn rounded border-0 w-100 text-start text-light text-wrap text-break d-inline-flex align-items-center category-item"
                :class="selectedCategory == item.id ? 'active' : ''" style="width: 6rem;"
            >
                {{ item.name }}
                <img :src="item.image" class="ms-auto rounded-circle me-1" style="width: 25px; height: 25px;" />
                <span class="ms-auto1 badge">{{ item?.products }}</span>
            </a>
        </li>
        <li v-else-if="item.children && item.children.length > 0">
            <!-- v-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)" -->
            <div class="d-inline-flex align-items-center justify-content-start w-100">

                <!-- <a class="btn btn-toggle collapsed" :data-bs-target="'#sub-' + item.id" aria-expanded="false"></a> -->
                <button
                    class="btn btn-toggle collapsed"
                    data-bs-toggle="collapse" :data-bs-target="'#sub-' + item.id" aria-expanded="false">
                </button>
                <a
                    @click="navigate(item.id)"
                    class="btn rounded border-0 w-100 text-start d-inline-flex align-items-center category-item"
                    :class="selectedCategory == item.id ? 'active' : ''"
                    >
                    {{ item.name }}
                    <img :src="item.image" class="ms-auto rounded-circle me-1" style="width: 25px; height: 25px;" />
                    <span class="ms-auto1 badge">{{ item?.products }}</span>
                </a>
            </div>
                <!-- data-bs-toggle="collapse"  -->
            <div class="collapse" :id="'sub-' + item.id">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-11" style="padding-left: 25px;">
                    <template v-if="item.children.length">
                        <SidebarItem :data="item.children" @navigate="navigate" :selectedCategory="selectedCategory" />
                    </template>
                    <!-- <li v-for="(item1, index1) in item.children" :key="index1">
                        <a href="#" class="link-body-emphasis d-inline-flex text-decoration-none rounded">
                            {{ item1.name }}
                        </a>
                    </li> -->
                </ul>
            </div>
        </li>
    </template>
</template>


<script>
import SidebarItem from './SidebarItem';

export default {
    name: 'SidebarItemC',
    components: {
        SidebarItem,
    },
    props: ['data', 'subclass', 'selectedCategory'],
    emits: ['navigate'],
    setup(_, {emit}) {
        const navigate = (categoryId) => {
            emit('navigate', categoryId);
        };

        return {
            navigate,
        };
    },
}
</script>

<style lang="scss" scoped>
.btn-toggle {
    padding: .25rem .5rem;
    font-weight: 600;
    // color: var(--bs-emphasis-color);
    color: #000000;
    // width: 100%;
    // background-color: transparent;
    background-color: var(--bs-tertiary-bg);
    // background-color: rgba(var(--bs-danger-rgb), .25);
}
.btn-toggle.collapsed {
    // color: #000000;
    // color: #ffffff;
    background-color: transparent;
}

.btn-toggle:hover,
.btn-toggle:focus {
    // color: rgba(var(--bs-emphasis-color-rgb), .85);
    // color: #000000;
    background-color: var(--bs-tertiary-bg);
}
.category-item:hover > .badge{
    color: #000000 !important;
}
.category-item > .badge{
    width: 40px;
}
.btn-toggle:hover::before,
.btn-toggle:focus::before {
    color: #000000 !important;
}
.btn-toggle.collapsed::before {
    padding: 0 5px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f0da";
    color: #ffffff;
    // content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    // transition: transform .35s ease;
    // transform-origin: .5em 50%;
}

// [data-bs-theme="dark"] .btn-toggle::before {
//     content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
// }

// .btn-toggle[aria-expanded="true"] {
//     color: rgba(var(--bs-emphasis-color-rgb), .85);
// }

.btn-toggle::before {
    padding: 0 3px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f0d7";
    color: #000000;
}
.btn-toggle-nav a {
    padding: 5px 8px;
    // padding: .1875rem .5rem;
    margin-top: .125rem;
    // margin-left: 1.25rem;
    color: #ffffff;
}

.btn-toggle-nav a:hover,
.btn-toggle-nav a:focus, .active, .active>.btn-toggle::before, .active>span {
    background-color: var(--bs-tertiary-bg);
    color: #000000 !important;
}
</style>